import * as React from "react";
import * as ReactDOM from "react-dom";
import { $$ } from '../dom';
import { OpenLayerMap } from "./components/OpenLayerMap";

const OL_MAP_SELECTOR = '.js-ol-map';

export function OlMap(): void {
    const maps = $$(OL_MAP_SELECTOR);
    maps.forEach(map => {
            const lon = map.getAttribute('data-lon') ?? '';
            const lat = map.getAttribute('data-lat') ?? '';

            ReactDOM.render(
            <OpenLayerMap lon={lon} lat={lat} />,
            map,
        );
    })
}
